import GatewayBase from './gateway-base';

export default class AppReviewRestService extends GatewayBase {
  listApps = (status?: string) => {
    const params = status ? `?status=${status}` : '';

    return this.client.get(`/v1/admin/apps${params}`);
  };

  approveApp = (id: string) => {
    return this.client.post(`/v1/admin/apps/${id}/approve`);
  };

  rejectApp = (id: string, reviewNote: string) => {
    return this.client.post(`/v1/admin/apps/${id}/reject`, { reviewNote });
  };

  suspendApp = (id: string) => {
    return this.client.post(`/v1/admin/apps/${id}/suspend`);
  };
}
